import { jsx as i, Fragment as oe, jsxs as m } from "react/jsx-runtime";
import { c as st } from "react/compiler-runtime";
import p from "react";
import ft from "@mui/material/Menu";
import ut from "@mui/material/FormControl";
import ht from "@mui/material/ListSubheader";
import { isEqual as ae } from "lodash";
import re from "@mui/icons-material/KeyboardArrowDown";
import mt from "@mui/icons-material/Close";
import dt from "@mui/icons-material/Search";
import { Box as u } from "../../atoms/Box/Box.js";
import { Checkbox as gt } from "../../atoms/Checkbox/Checkbox.js";
import { FormLabel as xt } from "../../atoms/FormLabel/FormLabel.js";
import { Grid as bt } from "../../atoms/Grid/Grid.js";
import { Typography as ee } from "../../atoms/Typography/Typography.js";
import { styles as y } from "../../atoms/Select/Select.styles.js";
import { searchSelectorStyles as o } from "./SearchSelector.styles.js";
const pe = (t) => {
  if (typeof t == "string") return t;
  const e = t, d = e.value;
  return d && typeof d == "object" && "id" in d ? String(d.id) : String(typeof d == "string" || typeof d == "number" ? d : e.label);
}, ot = (t) => typeof t == "string" ? t : String(t.label), Nt = (t) => {
  const e = st(152), {
    variant: d,
    size: et,
    valueLayout: tt
  } = t, a = d === void 0 ? "outlined" : d, at = et === void 0 ? "small" : et, v = tt === void 0 ? "ellipsis" : tt, C = at === "medium" ? "40px" : "32px", Ve = t.capitalize !== !1, [A, Me] = p.useState(null), [L, lt] = p.useState(""), nt = p.useRef(null), Ke = p.useRef(null), k = !!A, ce = t.width !== void 0 && t.width !== null, R = !!t.fullWidth && !ce, z = ce ? t.width : R ? "100%" : "auto", te = t.value === void 0 || t.value === null || t.value === "" || Array.isArray(t.value) && t.value.length === 0, E = !R && !ce && te ? y.emptySelectMinWidth : void 0;
  let se, fe;
  e[0] !== k ? (se = () => {
    if (k) {
      const l = window.setTimeout(() => nt.current?.focus(), 0);
      return () => window.clearTimeout(l);
    }
  }, fe = [k], e[0] = k, e[1] = se, e[2] = fe) : (se = e[1], fe = e[2]), p.useEffect(se, fe);
  let ue;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ue = (l) => {
    Me(l.currentTarget);
  }, e[3] = ue) : ue = e[3];
  const rt = ue;
  let I;
  if (e[4] !== t.options || e[5] !== t.searchAccessor || e[6] !== L) {
    e: {
      const l = L.trim().toLowerCase();
      if (t.searchAccessor && l.length > 0) {
        I = t.options.filter((n) => t.searchAccessor(n, l));
        break e;
      }
      if (typeof t.options[0] == "string" && l.length > 0) {
        I = t.options.filter((n) => n.toLowerCase().includes(l));
        break e;
      }
      if (typeof t.options[0] == "object" && l.length > 0) {
        I = t.options.filter((n) => typeof n == "string" ? !1 : n.label.toLowerCase().includes(l));
        break e;
      }
      I = t.options;
    }
    e[4] = t.options, e[5] = t.searchAccessor, e[6] = L, e[7] = I;
  } else
    I = e[7];
  const S = I;
  let le;
  e: {
    if (!t.multiple) {
      let s;
      e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = [], e[8] = s) : s = e[8], le = s;
      break e;
    }
    const l = t.value;
    if (l.length === 0) {
      let s;
      e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = [], e[9] = s) : s = e[9], le = s;
      break e;
    }
    const n = t.options.some(yt), r = l.every(vt);
    if (!n || !r) {
      le = l;
      break e;
    }
    let c;
    e[10] !== l ? (c = new Set(l.map(St)), e[10] = l, e[11] = c) : c = e[11];
    const f = c;
    let b;
    if (e[12] !== t.options || e[13] !== f) {
      let s;
      e[15] !== f ? (s = (w) => typeof w == "string" ? f.has(w) : f.has(String(w.value)), e[15] = f, e[16] = s) : s = e[16], b = t.options.filter(s), e[12] = t.options, e[13] = f, e[14] = b;
    } else
      b = e[14];
    le = b;
  }
  const g = le;
  let he;
  e[17] !== t.multiple || e[18] !== t.value || e[19] !== g ? (he = (l) => t.multiple ? g.some((n) => ae(n, l)) : typeof t.value == "string" && typeof l != "string" ? ae(l.value, t.value) : ae(t.value, l), e[17] = t.multiple, e[18] = t.value, e[19] = g, e[20] = he) : he = e[20];
  const O = he;
  let me;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (me = () => {
    Me(null), lt("");
  }, e[21] = me) : me = e[21];
  const it = me;
  let de;
  e[22] !== O || e[23] !== t || e[24] !== g ? (de = (l) => {
    if (t.multiple) {
      const n = O(l) ? g.filter((r) => !ae(r, l)) : [...g, l];
      t.onChange(n);
      return;
    }
    t.onChange(l), it();
  }, e[22] = O, e[23] = t, e[24] = g, e[25] = de) : de = e[25];
  const qe = de;
  let W;
  if (e[26] !== S) {
    W = {};
    for (let l = 0; l < S.length; l++) {
      const n = S[l];
      if (typeof n == "string")
        continue;
      const r = n;
      r.group && (W[r.group] ? W[r.group].push(r) : W[r.group] = [r]);
    }
    e[26] = S, e[27] = W;
  } else
    W = e[27];
  const Ne = W;
  let ge;
  e[28] !== Ne ? (ge = Object.entries(Ne), e[28] = Ne, e[29] = ge) : ge = e[29];
  const xe = ge;
  let ne;
  e: {
    if (t.multiple) {
      ne = !1;
      break e;
    }
    const l = t.value;
    if (l == null || l === "") {
      ne = !1;
      break e;
    }
    if (typeof l == "object" && "value" in l) {
      const n = l.value;
      ne = n != null && n !== "";
      break e;
    }
    ne = !0;
  }
  const ct = ne;
  let be;
  e[30] !== t ? (be = (l) => {
    l.stopPropagation(), !t.multiple && t.onChange("");
  }, e[30] = t, e[31] = be) : be = e[31];
  const Ge = be;
  let B;
  e: {
    if (typeof t.value == "string") {
      if (!t.value) {
        B = "";
        break e;
      }
      const l = t.options[0];
      if (t.options.length > 0 && typeof l == "object") {
        let n;
        if (e[32] !== t.options || e[33] !== t.value) {
          let c;
          e[35] !== t.value ? (c = (f) => typeof f == "string" ? !1 : ae(f.value, t.value), e[35] = t.value, e[36] = c) : c = e[36], n = t.options.find(c), e[32] = t.options, e[33] = t.value, e[34] = n;
        } else
          n = e[34];
        const r = n;
        if (r && typeof r != "string") {
          B = r.label;
          break e;
        }
      }
      B = t.value;
      break e;
    }
    if (typeof t.value == "object") {
      B = t.value.label;
      break e;
    }
    B = String(t.value);
  }
  const ye = te ? t.placeholder ?? "" : B, x = t.multiple, D = !x && !!t.clearable && ct, P = !x && !!t.clearable;
  let ie;
  e: {
    const l = !x && a !== "none" && v !== "wrap" && !t.clearable, n = ce ? t.width : R ? "100%" : void 0, r = t.height ?? (l ? C : void 0);
    let c;
    e[37] !== n || e[38] !== r ? (c = {
      width: n,
      height: r
    }, e[37] = n, e[38] = r, e[39] = c) : c = e[39];
    const f = c;
    let b;
    e[40] !== x ? (b = x ? {
      height: "auto",
      minHeight: "32px",
      overflow: "visible",
      flexWrap: "wrap",
      py: "4px"
    } : {}, e[40] = x, e[41] = b) : b = e[41];
    const s = b;
    let w;
    e[42] !== C || e[43] !== x || e[44] !== v ? (w = !x && v === "wrap" ? {
      height: "auto",
      minHeight: C,
      alignItems: "flex-start",
      overflow: "visible"
    } : {}, e[42] = C, e[43] = x, e[44] = v, e[45] = w) : w = e[45];
    const U = w;
    let je;
    e[46] !== P || e[47] !== a ? (je = P && a !== "none" ? {
      paddingRight: "8px"
    } : {}, e[46] = P, e[47] = a, e[48] = je) : je = e[48];
    const X = je;
    let _e;
    e[49] !== C || e[50] !== P || e[51] !== a ? (_e = P && a !== "none" ? [o.clearableTrigger, {
      minHeight: C
    }] : [], e[49] = C, e[50] = P, e[51] = a, e[52] = _e) : _e = e[52];
    const Z = _e;
    if (a === "none") {
      let h;
      e[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = {
        position: "relative"
      }, e[53] = h) : h = e[53];
      let He;
      e[54] !== Z || e[55] !== s || e[56] !== X || e[57] !== f || e[58] !== U ? (He = [y.selectControlSurfaceNone, f, h, s, U, X, ...Z], e[54] = Z, e[55] = s, e[56] = X, e[57] = f, e[58] = U, e[59] = He) : He = e[59], ie = He;
      break e;
    }
    let Fe;
    e[60] !== Z || e[61] !== s || e[62] !== X || e[63] !== f || e[64] !== U ? (Fe = [y.selectControlSurface, f, s, U, X, ...Z], e[60] = Z, e[61] = s, e[62] = X, e[63] = f, e[64] = U, e[65] = Fe) : Fe = e[65];
    const T = Fe;
    if (a === "filled") {
      let h;
      e[66] !== T ? (h = [...T, y.selectControlSurfaceFilled], e[66] = T, e[67] = h) : h = e[67], ie = h;
      break e;
    }
    if (a === "outlined") {
      let h;
      e[68] !== T ? (h = [...T, y.selectControlSurfaceOutlined], e[68] = T, e[69] = h) : h = e[69], ie = h;
      break e;
    }
    ie = T;
  }
  const Ye = ie;
  let ve;
  e: {
    if (t.autoWidth) {
      ve = o.menuPaper;
      break e;
    }
    if (A) {
      const l = `${A.clientWidth}px`;
      let n;
      e[70] !== l ? (n = [o.menuPaper, {
        minWidth: l
      }], e[70] = l, e[71] = n) : n = e[71], ve = n;
      break e;
    }
    ve = o.menuPaper;
  }
  const $e = ve;
  let Se;
  e[72] !== Ve ? (Se = Ve ? {
    textTransform: "capitalize"
  } : void 0, e[72] = Ve, e[73] = Se) : Se = e[73];
  const Qe = Se;
  let we;
  e[74] !== Qe || e[75] !== qe || e[76] !== t ? (we = (l, n, r) => {
    const c = typeof l != "string" && !!l.disabled, f = t.renderOption ? t.renderOption(l, n) : /* @__PURE__ */ m(oe, { children: [
      t.startIcon ? /* @__PURE__ */ i(u, { component: "span", sx: o.startIcon, children: t.startIcon }) : typeof l != "string" && l.icon ? /* @__PURE__ */ i(u, { component: "span", sx: o.startIcon, children: l.icon }) : null,
      /* @__PURE__ */ i(ee, { sx: {
        fontSize: "12px",
        fontWeight: 400
      }, children: ot(l) })
    ] });
    return /* @__PURE__ */ m(u, { onClick: () => {
      c || qe(l);
    }, sx: [o.optionRow, n && o.optionRowSelected, c && o.optionRowDisabled], style: Qe, children: [
      t.multiple && /* @__PURE__ */ i(gt, { checked: n, size: "small", sx: {
        p: 0
      }, tabIndex: -1, onChange: wt }),
      f
    ] }, r);
  }, e[74] = Qe, e[75] = qe, e[76] = t, e[77] = we) : we = e[77];
  const Ce = we;
  let ke;
  e[78] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ke = {
    position: "absolute",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#5B5B5B",
    width: 24,
    height: 24,
    pointerEvents: "none"
  }, e[78] = ke) : ke = e[78];
  const Ie = ke;
  let j;
  e[79] !== a ? (j = [o.triggerActions, ...a === "none" ? [{
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    marginLeft: 0
  }] : []], e[79] = a, e[80] = j) : j = e[80];
  let _;
  e[81] !== Ge || e[82] !== D ? (_ = D ? /* @__PURE__ */ i(mt, { sx: o.clearIcon, onClick: Ge, "aria-label": "Clear selection" }) : null, e[81] = Ge, e[82] = D, e[83] = _) : _ = e[83];
  const Je = a === "none" && o.chevronIconNone;
  let F;
  e[84] !== Je ? (F = /* @__PURE__ */ i(re, { sx: [o.chevronIcon, Je] }), e[84] = Je, e[85] = F) : F = e[85];
  let Oe;
  e[86] !== j || e[87] !== _ || e[88] !== F ? (Oe = /* @__PURE__ */ m(u, { sx: j, children: [
    _,
    F
  ] }), e[86] = j, e[87] = _, e[88] = F, e[89] = Oe) : Oe = e[89];
  const Ue = Oe;
  let We;
  e[90] !== te ? (We = te ? {
    color: Ct
  } : {}, e[90] = te, e[91] = We) : We = e[91];
  const Te = We;
  let Ae;
  e[92] !== Te || e[93] !== t.clearable ? (Ae = t.clearable ? [o.valueLabel, Te] : {
    fontSize: "12px",
    fontWeight: 400,
    ...Te
  }, e[92] = Te, e[93] = t.clearable, e[94] = Ae) : Ae = e[94];
  const Le = Ae;
  let Re;
  e[95] !== ye || e[96] !== t.clearable || e[97] !== t.multiple || e[98] !== t.startIcon || e[99] !== g || e[100] !== D || e[101] !== Le || e[102] !== Ue || e[103] !== v || e[104] !== a ? (Re = /* @__PURE__ */ i(oe, { children: t.multiple ? /* @__PURE__ */ m(oe, { children: [
    /* @__PURE__ */ i(u, { sx: o.multiChips, children: g.map((l) => /* @__PURE__ */ m(u, { component: "span", sx: o.chip, onClick: kt, children: [
      t.startIcon ? /* @__PURE__ */ i(u, { component: "span", sx: o.startIcon, children: t.startIcon }) : null,
      /* @__PURE__ */ i(ee, { component: "span", sx: {
        fontSize: "12px",
        fontWeight: 400
      }, children: ot(l) })
    ] }, pe(l))) }),
    a !== "none" ? /* @__PURE__ */ i(re, { sx: Ie }) : /* @__PURE__ */ i(re, { sx: {
      ...Ie,
      color: "#878787",
      width: 20,
      height: 20
    } })
  ] }) : t.clearable ? /* @__PURE__ */ m(oe, { children: [
    /* @__PURE__ */ m(u, { sx: [o.valueText, ...a === "none" || v === "wrap" ? [o.valueTextWrap] : [], ...a === "none" && D ? [{
      paddingRight: "44px"
    }] : []], children: [
      t.startIcon ? /* @__PURE__ */ i(u, { component: "span", sx: o.startIcon, children: t.startIcon }) : null,
      /* @__PURE__ */ i(ee, { component: "span", sx: Le, children: ye })
    ] }),
    Ue
  ] }) : /* @__PURE__ */ m(oe, { children: [
    /* @__PURE__ */ m(u, { component: "span", sx: [o.valueText, (a === "none" || v === "wrap") && o.valueTextWrap], children: [
      t.startIcon ? /* @__PURE__ */ i(u, { component: "span", sx: o.startIcon, children: t.startIcon }) : null,
      /* @__PURE__ */ i(ee, { component: "span", sx: Le, children: ye })
    ] }),
    a !== "none" ? /* @__PURE__ */ i(re, { sx: Ie }) : /* @__PURE__ */ i(re, { sx: {
      ...Ie,
      color: "#878787",
      width: 20,
      height: 20
    } })
  ] }) }), e[95] = ye, e[96] = t.clearable, e[97] = t.multiple, e[98] = t.startIcon, e[99] = g, e[100] = D, e[101] = Le, e[102] = Ue, e[103] = v, e[104] = a, e[105] = Re) : Re = e[105];
  const Xe = Re;
  let H;
  e[106] !== z || e[107] !== E ? (H = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: z,
    ...E
  }, e[106] = z, e[107] = E, e[108] = H) : H = e[108];
  const Ze = a === "none" ? "standard" : a;
  let V;
  e[109] !== z || e[110] !== E ? (V = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: z,
    ...E
  }, e[109] = z, e[110] = E, e[111] = V) : V = e[111];
  let M;
  e[112] !== t.label ? (M = t.label ? /* @__PURE__ */ i(xt, { component: "legend", sx: y.label, children: t.label }) : null, e[112] = t.label, e[113] = M) : M = e[113];
  let ze;
  e[114] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ze = (l) => {
    (l.key === "Enter" || l.key === " ") && (l.preventDefault(), Ke.current && Me(Ke.current));
  }, e[114] = ze) : ze = e[114];
  let K;
  e[115] !== t.style || e[116] !== Xe || e[117] !== Ye ? (K = /* @__PURE__ */ i(u, { ref: Ke, sx: Ye, style: t.style, onClick: rt, role: "button", tabIndex: 0, onKeyDown: ze, children: Xe }), e[115] = t.style, e[116] = Xe, e[117] = Ye, e[118] = K) : K = e[118];
  let q;
  e[119] !== $e ? (q = {
    paper: {
      sx: $e
    }
  }, e[119] = $e, e[120] = q) : q = e[120];
  let Ee;
  e[121] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ee = {
    sx: {
      padding: 0
    }
  }, e[121] = Ee) : Ee = e[121];
  let Be;
  e[122] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Be = (l) => lt(l.target.value), e[122] = Be) : Be = e[122];
  let N;
  e[123] !== L ? (N = /* @__PURE__ */ i("input", { ref: nt, type: "text", value: L, onChange: Be, onKeyDown: It }), e[123] = L, e[124] = N) : N = e[124];
  let De;
  e[125] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (De = /* @__PURE__ */ i(dt, { sx: o.searchIcon }), e[125] = De) : De = e[125];
  let G;
  e[126] !== N ? (G = /* @__PURE__ */ m(u, { sx: o.searchRow, children: [
    N,
    De
  ] }), e[126] = N, e[127] = G) : G = e[127];
  let Y;
  e[128] !== S || e[129] !== xe || e[130] !== O || e[131] !== t.emptyStateText || e[132] !== Ce ? (Y = S.length === 0 ? /* @__PURE__ */ i(ee, { sx: o.emptyState, children: t.emptyStateText ?? "No options available" }) : xe.length ? xe.map((l) => {
    const [n, r] = l;
    return /* @__PURE__ */ m(p.Fragment, { children: [
      /* @__PURE__ */ i(ht, { component: "div", sx: y.groupHeader, children: /* @__PURE__ */ i(bt, { container: !0, sx: y.groupHeaderContainer, children: /* @__PURE__ */ i(ee, { sx: y.groupHeaderText, children: n }) }) }),
      r.map((c) => Ce(c, O(c), pe(c)))
    ] }, n);
  }) : S.map((l) => Ce(l, O(l), pe(l))), e[128] = S, e[129] = xe, e[130] = O, e[131] = t.emptyStateText, e[132] = Ce, e[133] = Y) : Y = e[133];
  let $;
  e[134] !== Y ? ($ = /* @__PURE__ */ i(u, { sx: o.optionsScroll, children: Y }), e[134] = Y, e[135] = $) : $ = e[135];
  let Q;
  e[136] !== A || e[137] !== k || e[138] !== q || e[139] !== G || e[140] !== $ ? (Q = /* @__PURE__ */ m(ft, { open: k, anchorEl: A, onClose: it, slotProps: q, MenuListProps: Ee, disableAutoFocus: !0, children: [
    G,
    $
  ] }), e[136] = A, e[137] = k, e[138] = q, e[139] = G, e[140] = $, e[141] = Q) : Q = e[141];
  let J;
  e[142] !== R || e[143] !== Ze || e[144] !== V || e[145] !== M || e[146] !== K || e[147] !== Q ? (J = /* @__PURE__ */ m(ut, { variant: Ze, hiddenLabel: !0, fullWidth: R, sx: V, children: [
    M,
    K,
    Q
  ] }), e[142] = R, e[143] = Ze, e[144] = V, e[145] = M, e[146] = K, e[147] = Q, e[148] = J) : J = e[148];
  let Pe;
  return e[149] !== H || e[150] !== J ? (Pe = /* @__PURE__ */ i(u, { sx: H, children: J }), e[149] = H, e[150] = J, e[151] = Pe) : Pe = e[151], Pe;
};
function yt(t) {
  return typeof t != "string";
}
function vt(t) {
  return typeof t == "string";
}
function St(t) {
  return String(t);
}
function wt() {
}
function Ct(t) {
  return t.vars?.palette.grey[500] ?? t.palette.grey[500];
}
function kt(t) {
  t.stopPropagation();
}
function It(t) {
  return t.stopPropagation();
}
export {
  Nt as default
};
